<template>
  <div class="h-full animate-pulse overflow-hidden">
    <div class="flex h-full flex-col lg:flex-row">
      <div class="top-0 h-fit w-full pt-12 lg:h-full lg:w-1/2 lg:pt-7 lg:shadow-primary">
        <div class="mx-6 mb-4 h-7 w-1/2 rounded-lg bg-secondary lg:mx-9" />
        <ul class="flex gap-2 overflow-hidden px-6 lg:grid lg:grid-cols-2 lg:pl-9 lg:pr-7">
          <UiCard
            v-for="item in 4"
            :key="item"
            tag="li"
            class="flex w-full cursor-pointer select-none flex-col rounded-full px-5 py-3"
          >
            <div class="mb-1 h-4.5 w-full rounded-lg bg-secondary" />
          </UiCard>
        </ul>
      </div>
      <div
        class="relative size-full p-7 px-6 lg:w-1/2 lg:border-l lg:border-fivefold lg:pl-7 lg:pr-9 lg:pt-7"
      >
        <div v-for="item in 5" :key="item + 'item'" class="mb-6">
          <div class="mb-2 h-5 w-24 rounded-lg bg-secondary" />
          <ul class="flex flex-col gap-2">
            <UiCard
              v-for="card in 4"
              :key="card + 'card'"
              tag="li"
              class="flex w-full cursor-pointer select-none justify-between px-5 py-3"
            >
              <div>
                <div class="mb-1 h-4 w-8 rounded-lg bg-secondary" />
                <div class="h-3.5 w-12 rounded-lg bg-secondary" />
              </div>
              <div class="mb-1 h-4 w-12 rounded-lg bg-secondary" />
            </UiCard>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiCard } from '@/6_shared/ui'
</script>
